import React from 'react';
import Navbar from '../../Navbar/Navbar';
import ProductDetailsPage from '../ProductDetails/ProductDetails';
import Footer from '../../Footer/Footer';

const ProductDetails = () => {
  return (
    <div>
      <Navbar />
      <ProductDetailsPage />
      <Footer />
    </div>
  );
};

export default ProductDetails;
